function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#USD_svg__clip0_1_119)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15z",
  fill: "#2685DB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.75 13.487c-1.963-.75-2.775-1.2-2.775-2.037 0-.475.262-1.05 1.525-1.05 1.237 0 2.587.712 3.387 1.15l1.138-2.2c-.75-.475-2.038-1.025-3.563-1.25l-.137-.025V6.487h-2.588v1.625l-.125.025c-1.962.45-3.237 1.788-3.237 3.425 0 2.05 1.137 3.313 3.925 4.363 1.287.487 2.225.837 2.225 1.837 0 .888-.675 1.413-1.8 1.413-1.3 0-3.2-1.138-3.75-1.488l-1.1 2.388c1.237.737 2.45 1.187 3.737 1.4l.138.025v2.025h2.587v-2l.125-.025c2.2-.413 3.675-1.988 3.675-3.913-.012-1.975-.987-3.162-3.387-4.1z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "USD_svg__clip0_1_119"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h30v30H0z"
})));

function SvgUsd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "a64e87f0e5f6da8660af8efc312830e3.svg";
export { SvgUsd as ReactComponent };